export default __webpack_public_path__ + "static/media/mauquenchy11.e46e88d8.jpg";